<template>
    <div class="rx-app-container">
        <HanderNav title="融星贷"></HanderNav>
        <ApplicationResult :isSuccess="isSuccess" :items="products" @select="onSelectProduct" />
    </div>

</template>
<script>
import HanderNav from "../components/HanderNav.vue";
import ApplicationResult from '../components/ApplicationResult.vue';
import { getAds, getUrl } from "../api";
export default {
    components: {
        HanderNav,
        ApplicationResult,
    },
    created() {
        var channel_id = this.$route.query?.channel_id
        var stage = this.$route.query?.stage
        if (!channel_id || !stage) {
            this.$router.push('/404');
            return;
        }
        this.channel_id = channel_id;
        console.log(stage == "approved", stage, 456)
        this.isSuccess = stage == "approved";
        getAds(channel_id).then(res => {
            if (res.code === 1 && res.data) {
                var v = [];
                for (var item of res.data.data) {
                    v.push({
                        id: item.id,
                        title: item.name,
                        name: item.remark,
                        amount: item.loan_amount,
                        isChecked: false,
                    })
                }
                this.products = v;
            }
        })
    },
    data() {
        return {
            isSuccess: false,
            products: [],
            channel_id: '',
            url: '',
        }
    },
    methods: {
        onSelectProduct(row) {
            getUrl(row.id, this.channel_id).then(res => {
                if (res.code === 1 && res.data.hyperlink) {
                    this.url = res.data.hyperlink;
                    console.log('跳转链接', this.url)
                    setTimeout(() => {
                        row.loading = false;
                    }, 500);
                    window.location.href = res.data.hyperlink
                }
            })
        }
    }
}
</script>

<style lang="less" scoped>
.rx-app-container {
    position: relative;
    width: 100%;
    background: linear-gradient(180deg, #b9ddf2 -1.32%, #f3fbff 75.05%);
    min-height: 100vh;
    padding: 0 16px;
}
</style>